import { AlertTriangle, X } from 'lucide-react';
import { colors } from '../../styles/colors';

function DeleteConnectionModal({
  isOpen,
  onClose,
  onConfirm,
  connection,
  isDeleting
}) {
  if (!isOpen || !connection) {
    return null;
  }

  const bankName = connection.bank_name || 'cette connexion';

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
        animation: 'slideIn 0.2s ease-out'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px 24px',
          borderBottom: `1px solid ${colors.border}`
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <AlertTriangle size={24} color={colors.status.error} />
            <h2 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: colors.text.primary,
              margin: 0
            }}>
              Supprimer la connexion
            </h2>
          </div>
          <button
            onClick={onClose}
            disabled={isDeleting}
            style={{
              background: 'none',
              border: 'none',
              cursor: isDeleting ? 'not-allowed' : 'pointer',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              color: colors.text.secondary,
              opacity: isDeleting ? 0.5 : 1
            }}
          >
            <X size={20} />
          </button>
        </div>

        <div style={{ padding: '24px' }}>
          <p style={{
            fontSize: '14px',
            color: colors.text.primary,
            lineHeight: '1.6',
            margin: '0 0 16px 0'
          }}>
            Êtes-vous sûr de vouloir supprimer <strong>{bankName}</strong> ?
          </p>
          <div style={{
            padding: '12px 16px',
            backgroundColor: colors.status.error + '10',
            borderLeft: `3px solid ${colors.status.error}`,
            borderRadius: '4px'
          }}>
            <p style={{
              fontSize: '13px',
              color: colors.text.secondary,
              margin: 0,
              lineHeight: '1.5'
            }}>
              <strong>Attention :</strong> Cette action supprimera également tous les comptes et transactions associés. Cette action est irréversible.
            </p>
          </div>
        </div>

        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '12px',
          padding: '16px 24px',
          borderTop: `1px solid ${colors.border}`,
          backgroundColor: '#fafafa'
        }}>
          <button
            onClick={onClose}
            disabled={isDeleting}
            style={{
              padding: '10px 20px',
              backgroundColor: 'white',
              color: colors.text.primary,
              border: `1px solid ${colors.border}`,
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: isDeleting ? 'not-allowed' : 'pointer',
              opacity: isDeleting ? 0.5 : 1,
              transition: 'all 0.2s'
            }}
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            style={{
              padding: '10px 20px',
              backgroundColor: colors.status.error,
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: isDeleting ? 'not-allowed' : 'pointer',
              opacity: isDeleting ? 0.6 : 1,
              transition: 'all 0.2s'
            }}
          >
            {isDeleting ? 'Suppression...' : 'Supprimer'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConnectionModal;
